// extracted by mini-css-extract-plugin
export var boldText = "_6g-4";
export var checkboxContainer = "_6g-6";
export var closeIcon = "_6g-i";
export var container = "_6g-0";
export var drawer = "_6g-8";
export var drawerContent = "_6g-9";
export var extraSmallText = "_6g-5";
export var fulfillmentGroupTable = "_6g-e";
export var largeText = "_6g-3";
export var loadingSpinnerContainer = "_6g-j";
export var mediumText = "_6g-2";
export var narrow = "_6g-f";
export var notificationLink = "_6g-l";
export var packageCheckIconContainer = "_6g-7";
export var slideoutHeaderActions = "_6g-g";
export var slideoutHeaderActionsShifted = "_6g-h";
export var slideoutHeaderContainer = "_6g-a";
export var slideoutModal = "_6g-c";
export var stickyHeaderWrapper = "_6g-b";
export var table = "_6g-k";
export var tableContainer = "_6g-d";
export var tertiaryText = "_6g-1";